import React, { FC } from 'react';
import { Box, Button, Tooltip } from '@mui/material';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AddIcon from '@mui/icons-material/Add';
import TaskIcon from '@mui/icons-material/Task';

interface ControlsProps {
  onAdd: () => void;
  onConvert: () => void;
  onDownload: () => void;
}

export const Controls: FC<ControlsProps> = (props) => {
  const { onAdd, onConvert, onDownload } = props

  return <Box sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      mt: 2,
      gap: 1
    }}
  >
    <Tooltip title="Download File">
      <Button
        endIcon={<FileDownloadIcon />}
        variant="contained"
        onClick={onDownload}
      >
        Download
      </Button>
    </Tooltip>
    <Tooltip title="Upload File">
      <Button
        onClick={onAdd}
        endIcon={<AddIcon />}
        variant="contained"
      >
        Upload
      </Button>
    </Tooltip>
    <Tooltip title="Convert File">
      <Button
        onClick={onConvert}
        endIcon={<TaskIcon />}
        variant="contained"
      >
        Convert
      </Button>
    </Tooltip>
  </Box>
};
